import { DataModel } from '../../dto/dto.js';
import { BusinessModuleRef } from '../business-module-ref.js';
import { PaymentMethod } from '../payment-method.js';
import { PaymentType } from '../payment-type.js';
import { Language } from '../language.js';
import { OrderDomain } from '../order-domain.js';
import { OfflineReceiptType } from '../invoicing/offline-receipt-type.js';
import { CartCustomerDto } from './cart-customer.js';

export abstract class OfflineCartBase extends DataModel {
  abstract get businessRef(): BusinessModuleRef;
  abstract get creatorId(): string;
  abstract get customerId(): string | null;
  abstract get customer(): CartCustomerDto | null;
  abstract get paymentType(): PaymentType;
  abstract get paymentMethod(): PaymentMethod;
  abstract get language(): Language;
  abstract get domain(): OrderDomain;
  abstract get allowOfflineOrderReceipts(): boolean | null;
  abstract get receiptType(): OfflineReceiptType | null;
}
